import bem from "easy-bem";
import { useIsMobile } from "hooks/useIsMobile";
import React, {
  MouseEventHandler,
  ReactElement,
  ReactNode,
  forwardRef,
  Ref,
} from "react";
import "./BubbleButton.css";
import "./BubbleButton.new.css";

type OwnProps = {
  text?: string | ReactNode | ReactElement;
  round?: "left" | "right" | "both" | "none";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  backgroundColor?: string;
  borderColor?: string;
  variant?: "default" | "circle";
  autosize?: boolean;
  size?: "default" | "s" | "m" | "l";
  square?: boolean;
  className?: string;
  disabled?: boolean;
  icon?: string | null;
  group?: boolean;
  suffix?: string;
};

const BubbleButton = forwardRef<HTMLButtonElement, OwnProps>(
  (
    {
      text,
      round = "both",
      onClick,
      backgroundColor = "#eee",
      borderColor = "#999",
      variant = "default",
      autosize = false,
      square = false,
      size = "default",
      className = "",
      disabled = false,
      icon = null,
      group = false,
      suffix = "",
    },
    ref: Ref<HTMLButtonElement>,
  ) => {
    const { isMobile } = useIsMobile();

    const cn = bem("bubble-button" + suffix);

    const cleanedText =
      typeof text === "string" ? text.trim().replace(/ +/g, " ") : text;

    const buttonStyle = {
      backgroundColor,
      borderColor,
    };

    return (
      <button
        ref={ref}
        className={
          cn({
            round,
            variant,
            mobile: isMobile,
            autosize,
            size,
            square,
            disabled,
            group,
          }) +
          " " +
          className
        }
        style={buttonStyle}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
      >
        <span className={cn("typography")}>
          {icon && (
            <img
              src={icon}
              className="bubble-button-icon"
            />
          )}
          {cleanedText}
        </span>
      </button>
    );
  },
);

BubbleButton.displayName = "BubbleButton";

export default BubbleButton;
